import React from 'react';

//types
import { IIconRotatableProps } from 'assets/icons/IconProps';

export const DividerIcon = ({
  width = 24,
  height = 24,
  stroke = '#DBDDE0',
}: IIconRotatableProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 1 24"
    fill="none"
  >
    <line x1="0.5" y1="2.18557e-08" x2="0.499999" y2="24" stroke={stroke} />
  </svg>
);
